import type {
  CnCOrderResponse,
  CnCTransactionResponse,
} from "../types/api";

type OrderLike = Pick<
  CnCOrderResponse | CnCTransactionResponse,
  "deliveryType" | "userAddressResponse"
>;

export const isFriendPickup = (o: OrderLike) =>
  o.deliveryType === "PICK_UP_BY_FRIEND";

// Backend treats PICK_UP_BY_FRIEND as pickup (skips distance check, permits, DELIVERY_USER
// role, loyalty handling; strips userAddressResponse on transactions). We match that here.
export const isDelivery = (o: OrderLike) =>
  o.userAddressResponse != null && !isFriendPickup(o);

export const isPickup = (o: OrderLike) => !isDelivery(o);

export const isVolunteerDelivery = (o: OrderLike) =>
  o.deliveryType === "FAST_DELIVERY" ||
  o.deliveryType === "STANDARD_DELIVERY" ||
  o.deliveryType === "PENSION_CARD_DELIVERY";

export const needsDeliveryPermit = (o: OrderLike) =>
  isVolunteerDelivery(o) || isFriendPickup(o);

export const isFastDelivery = (o: OrderLike) =>
  o.deliveryType === "FAST_DELIVERY";

export const showsDeliveryVanIcon = (o: OrderLike) =>
  o.deliveryType === "STANDARD_DELIVERY" ||
  o.deliveryType === "PENSION_CARD_DELIVERY";
